import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

// Anasayfa tanıtım şeridi — admin-yönetimli (homepage_banners). Pollo tarzı yatay kartlar.
// Aktif banner yoksa hiçbir şey render etmez (boşluk bırakmaz).
interface Banner { id: string; title: string; subtitle: string | null; media_url: string | null; link_url: string | null; badge: string | null }

const isVideo = (u: string) => /\.(mp4|webm|mov)(\?|$)/i.test(u);

export const BannerStrip = () => {
  const navigate = useNavigate();
  const [banners, setBanners] = useState<Banner[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await (supabase as any).from("homepage_banners")
          .select("id, title, subtitle, media_url, link_url, badge, is_active, display_order")
          .eq("is_active", true)
          .order("display_order", { ascending: true });
        setBanners((data as Banner[]) || []);
      } catch { /* tablo yoksa sessiz — şerit görünmez */ }
    })();
  }, []);

  if (!banners.length) return null;

  const go = (b: Banner) => {
    if (!b.link_url) return;
    if (/^https?:\/\//i.test(b.link_url)) window.open(b.link_url, "_blank");
    else navigate(b.link_url);
  };

  return (
    <section className="mx-auto max-w-6xl px-4 py-6">
      <div className="flex gap-3 overflow-x-auto pb-2 sm:gap-4">
        {banners.map((b) => (
          <button
            key={b.id}
            onClick={() => go(b)}
            className={`group relative aspect-[4/3] w-64 shrink-0 overflow-hidden rounded-2xl border border-white/10 bg-neutral-900 text-left sm:w-72 ${b.link_url ? "cursor-pointer" : "cursor-default"}`}
          >
            {b.media_url && (
              isVideo(b.media_url)
                ? <video src={b.media_url} autoPlay muted loop playsInline className="absolute inset-0 h-full w-full object-cover opacity-90 transition group-hover:scale-105" />
                : <img src={b.media_url} alt={b.title} loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-90 transition group-hover:scale-105" />
            )}
            {/* okunabilirlik için alttan koyu degrade */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            {b.badge && <span className="absolute right-2 top-2 rounded-full bg-gradient-to-r from-[#E21D4B] to-[#FF6600] px-2 py-0.5 text-xs font-bold text-white">{b.badge}</span>}
            <div className="absolute inset-x-0 bottom-0 p-3">
              <h3 className="text-base font-bold text-white drop-shadow">{b.title}</h3>
              {b.subtitle && <p className="mt-0.5 line-clamp-2 text-xs text-white/80">{b.subtitle}</p>}
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};
